
<div id="page--letter-template">
  <form #f="ngForm">
    <div class="content__holder" *ngIf="!previewMode">
      <h2 class="heading">Configure text messages</h2>

      <loading-spinner *ngIf="isLoading"></loading-spinner>

      <div class="panel">
        <ul class="grid grid--row-2">
          <li>
            <mat-form-field>
              <mat-select id="textMessageTypes" name="textMessageTypes" [(ngModel)]="textMessageTypeId" (selectionChange)="textMessageTypeChanged()" placeholder="Text Message Type">
                <mat-option *ngFor="let textMessageType of textMessageTypes" [value]="textMessageType.textMessageTypeId">
                  {{textMessageType.textMessageTypeString}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </li>
        </ul>
      </div>

      <div class="panel">
        <ul class="grid grid--row-1" *ngIf="textMessageTemplate && !isLoading">
          <li>
            <mat-form-field>
              <div class="validation__holder">
                <textarea matInput name="text" id="text" maxlength="160" placeholder="Text Message Template" [(ngModel)]="textMessageTemplate.text" (input)="textEntered()" required></textarea>
                <div class="validation"></div>
              </div>
              <label class="text__count" *ngIf="remainingCharacterCount">Remaining characters: {{remainingCharacterCount}}</label>
            </mat-form-field>
          </li>
        </ul>
      </div>

      <div class="button__row" *ngIf="textMessageTemplate && !isLoading">
        <button class="button--box blue preview" (click)="preview()" [disabled]="isSaveDisabled()">Preview</button>
        <button class="button--box blue save" (click)="save()" [disabled]="isSaveDisabled()">Save</button>
      </div>
    </div>

    <!-- PREVIEW MODE -->
    <div class="content__holder text-preview" *ngIf="previewMode">
      <h2 class="heading">Text - {{textMessageTypeName}} (Preview)</h2>

      <ul class="text-preview__list" *ngIf="previewMode">
        <li class="text-preview__item">
          <h3>{{textMessageTemplate.text}}</h3>
        </li>
      </ul>

      <div class="button__row">
        <button class="button--box blue back" (click)="back()">Back</button>
      </div>

    </div>
    <!-- PREVIEW MODE -->


  </form>
</div>
